export const createTipoDocumentoModel = ({
  id_tipo_documento = '',
  tipo_documento = ''
} = {}) => ({
  id_tipo_documento,
  tipo_documento
});